import { Label } from '../Interface/Response/Interest/Label';

export const getLabel = (allLabels: Label[], finDataCodeToMatch?: string): Label =>
    allLabels.find(({ findataCode }) => findataCode === finDataCodeToMatch) as Label;
